<template>
    <div class="map-view">
        <div id="mapContainer"></div>
    </div>
</template>

<script>
import { MapUtils } from '@/utils/mapUtils';
import { useMapStore } from '@/stores/mapStore';


export default {
    name: 'MapView',
    data() {
        return {
        }
    },
    mounted() {
        const mapStore = useMapStore();
        mapStore.initMap("mapContainer");
        mapStore.addBaseLayer("baidu", MapUtils.createBaiduLayer());
        this.$emit('map-loaded', {  });
    },
    methods: {



    }
}

</script>

<style scoped>
.map-view {
    width: 100%;
    height: 100%;
}

#mapContainer {
    width: 100%;
    height: 100%;
}
</style>